module.exports = __webpack_public_path__ + "img/teppich2.3f5e1760.png";